import axiosInstance from './AxiosInstance';

const AuthService = {
    login: async (emailOrPhoneNumber, password) => {
        try {
            const response = await axiosInstance.post('/auth/login', {
                emailOrPhoneNumber,
                password
            });

            if (response.data.status === 'success') {
                const { accessToken, refreshToken } = response.data.data;
                localStorage.setItem('accessToken', accessToken);
                console.log("accessToken", accessToken);
                localStorage.setItem('refreshToken', refreshToken);
                console.log("refreshToken", refreshToken);
                return response.data;
            }

            return response.data;
        } catch (error) {
            console.error("Login error details:", error);
            throw error.response?.data || { message: 'Login failed' };
        }
    },


    logout: () => {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('userData');
    },

    refreshToken: async () => {
        try {
            const refreshToken = localStorage.getItem('refreshToken');
            if (!refreshToken) {
                throw new Error('No refresh token available');
            }

            const response = await axiosInstance.post('/auth/refresh-token', {
                refreshToken,
            });

            if (response.data.status === 'success') {
                const { accessToken, refreshToken: newRefreshToken } = response.data.data;
                localStorage.setItem('accessToken', accessToken);
                localStorage.setItem('refreshToken', newRefreshToken);
                return response.data;
            }

            return response.data;
        } catch (error) {
            throw error.response?.data || { message: 'Token refresh failed' };
        }
    },

    fetchStudentDetails: async (email) => {
        try {
            const response = await axiosInstance.post('/auth/fetch-student', { email });
            console.log("fetchStudentDetails response", response);
            return response.data;
        } catch (error) {
            throw error.response?.data || { message: 'Failed to fetch student details' };
        }
    },

    isAuthenticated: () => {
        return !!localStorage.getItem('accessToken');
    }
};

export default AuthService;
